// Shared formatting for assistant usage/cost surfaces (instance + global
// control center). Budget warning threshold matches the backend soft cap.
export const BUDGET_WARN_PERCENT = 80;

export const formatUsd = (value: number | undefined): string => {
  if (value === undefined) return '—';
  return `$${value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatTokens = (value: number | undefined): string => {
  if (value === undefined) return '—';
  return value.toLocaleString();
};

export const formatMs = (value: number): string =>
  `${Math.round(value).toLocaleString()} ms`;

export const formatPercent = (value: number | undefined): string => {
  if (value === undefined) return '—';
  return `${Math.round(value)}%`;
};

export const budgetColor = (percent: number | undefined): string =>
  percent !== undefined && percent >= BUDGET_WARN_PERCENT ? 'red' : 'blue';
